import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.move-credit-card-items.views.MoveItemsActionBar`

export default defineMessages({
  selectedSummary: {
    id: `${scope}.selectedSummary`,
    defaultMessage: '{count} credit card item(s) selected ({total})',
  },
  deselectAllButton: {
    id: `${scope}.deselectAllButton`,
    defaultMessage: 'Deselect all',
  },
  moveItemsButton: {
    id: `${scope}.moveItemsButton`,
    defaultMessage: 'Move items',
  },
})
